import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5f66396"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "Label light-caps",
  ref: "text"
}

import { withDefaults, ref } from 'vue'

interface Props {
  variant?: VARIANT
  theme?: THEME
}


import { defineComponent, nextTick, onMounted } from 'vue'
import { setFPS } from '@/utils/FrameToTime'
import { gsap } from "gsap"

export const enum VARIANT {
  NORMAL = 'normal',
  OUTLINE = 'outline'
}

export const enum THEME {
  TRANSPARENT = 'transparent',
  WHITE = 'white'
}

const __default__ = defineComponent({})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    variant: { default: VARIANT.NORMAL },
    theme: { default: THEME.TRANSPARENT }
  },
  setup(__props: any) {

const props = __props as { variant: VARIANT, theme: THEME }



const frames = setFPS(60)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(["UIBtn UIBtnPrimary", [`UIBtnPrimary--${__props.variant}`, `UIBtnPrimary--${__props.theme}`]]),
        ref: "root"
      }, [
        _createElementVNode("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ], 512)
      ], 2)
    ]),
    _: 3
  }))
}
}

})